<template>
  <v-dialog v-model="show" :max-width="maxWidth" :persistent="persistent" scrollable>
    <v-card>
      <v-card-title class="headline">{{ detailTecnology && detailTecnology.type }}</v-card-title>
      <v-card-text class="pa-0" style="max-height: 600px;">
        <v-list two-line class="card-list">
          <template v-for="(item, index) in detailTecnology && detailTecnology.items">
            <v-list-tile :key="index">
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <h5 class="mb-1">{{ item.title }}</h5>
                </v-list-tile-sub-title>
                <p class="mb-0 caption grey--text fw-normal text-xs-justify">{{ item.description }}</p>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            @click="close"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: '500'
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: false,
    detailTecnology: null
  }),
  methods: {
    async getDetail(type, code) {
      this.detailTecnology = null
      if (type === 'M') {
        await this.$store.dispatch('getCUMs', code)
            .then(response => {
              if (response.length) {
                const result = response[0]
                this.detailTecnology = {
                  type: 'Medicamento',
                  items: [
                    {title: 'Código', description: `${type}${code}`},
                    {title: 'Descripción comercial', description: `${result.descripcioncomercial}`},
                    {title: 'Producto', description: `${result.producto}`},
                    {title: 'Principio activo', description: `${result.principioactivo}`},
                    {title: 'Forma farmacéutica', description: `${result.formafarmaceutica}`},
                    {title: 'Vía de administración', description: `${result.viaadministracion}`},
                    {title: 'Rol', description: `${result.nombrerol} - ${result.tiporol}`},
                    {title: 'Titular', description: `${result.titular}`}
                  ]
                }
                this.$emit('onProcess', true)
                this.open()
              } else {
                this.$emit('onProcess', false)
                this.$store.commit('snackbar', {
                  color: 'warning',
                  message: `Servicio o tecnología ${type + '' + code} no encontrado.`
                })
              }
            })
            .catch(e => {
              this.$emit('onProcess', false)
              this.$store.commit('snackbar', {
                color: 'error',
                message: `al recuperar el servicio o tecnología ${type + '' + code}`,
                error: e
              })
            })
      } else if (type === 'P') {
        await this.$store.dispatch('getCUPS', code)
            .then(response => {
              console.log(response)
              if (response) {
                this.detailTecnology = {
                  type: 'Procedimiento',
                  items: [
                    {title: 'Código', description: `${response.codigo}`},
                    {title: 'Nombre', description: `${response.descripcion}`},
                  ]
                }
                this.$emit('onProcess', true)
                this.open()
              } else {
                this.$emit('onProcess', false)
                this.$store.commit('snackbar', {
                  color: 'warning',
                  message: `Servicio o tecnología ${type + '' + code} no encontrado.`
                })
              }
            })
            .catch(e => {
              console.log(e)
              this.$emit('onProcess', false)
              this.$store.commit('snackbar', {
                color: 'error',
                message: `al recuperar el servicio o tecnología ${type + '' + code}`,
                error: e
              })
            })
      } else {
        let url = ''
        switch (type) {
          case 'N':
            let resultN = this.$store.state.general.serTecs.nutricionales.find(x => x.codigo == code)
            if (resultN) {
              this.detailTecnology = {
                type: 'Producto de soporte nutricional',
                items: [
                  {title: 'Código', description: `${type}${code}`},
                  {title: 'Descripción', description: `${resultN.descripcion}`},
                  {title: 'Presentacion', description: `${resultN.presentacion} ${resultN.unidades}`},
                  {title: 'Forma', description: `${resultN.forma}`},
                  {title: 'Grupo', description: `${resultN.grupo}`}
                ]
              }
              this.$emit('onProcess', true)
              this.open()
            } else {
              this.$emit('onProcess', false)
              this.$store.commit('snackbar', {
                color: 'warning',
                message: `Producto de soporte nutricional ${type + '' + code} no encontrado.`
              })
            }
            break
          case 'S':
            let resultS = this.$store.state.general.serTecs.complementarios.find(x => x.codigo == code || x.codigo == ('0' + code))
            if (resultS) {
              this.detailTecnology = {
                type: 'Servicio complementario',
                items: [
                  {title: 'Código', description: `${type}${code}`},
                  {title: 'Descripción', description: `${resultS.descripcion}`}
                ]
              }
              this.$emit('onProcess', true)
              this.open()
            } else {
              this.$emit('onProcess', false)
              this.$store.commit('snackbar', {
                color: 'warning',
                message: `Servicio complementario ${type + '' + code} no encontrado.`
              })
            }
            break
          case 'D':
            let resultD = this.$store.state.general.serTecs.dispositivos.find(x => x.codigo == code)
            if (resultD) {
              this.detailTecnology = {
                type: 'Dispositivo',
                items: [
                  {title: 'Código', description: `${type}${code}`},
                  {title: 'Descripción', description: `${resultD.descripcion}`}
                ]
              }
              this.$emit('onProcess', true)
              this.open()
            } else {
              this.$emit('onProcess', false)
              this.$store.commit('snackbar', {
                color: 'warning',
                message: `Dispositivo ${type + '' + code} no encontrado.`
              })
            }
            break
        }
      }
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>
